/* Wubs – Lenis smooth scroll.
   wubs-lenis.min.js (UMD, globalThis.Lenis) laddas FÖRE denna fil.
   Gardering:
   - reduced-motion → kör inte alls
   - konfigurator-sidan (.wubs-stairs) har eget app-/scroll-läge → skippas
   - data-lenis-prevent på interna scroll-ytor (drawers, sök, meny, karuseller) → native wheel där
   - stop()/start() när en overlay låser sidan (drawers/meny sätter body.overflow = 'hidden') */
(function () {
  'use strict';
  if (typeof window.Lenis === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.querySelector('.wubs-stairs')) return; // konfiguratorns app-läge äger sin scroll
  /* PEKSKÄRMAR: Lenis gör ingenting där (syncTouch: false – telefonens egen momentum-scroll gäller), men
     rAF-loopen nedan gick ändå varje bildruta. Uppmätt i Lighthouse mobil 2026-10-29: wubs-lenis.js
     stod för ~11 s huvudtrådsarbete och den längsta uppgiften (346 ms) – den största posten i TBT 370–500 ms.
     Mus/styrplatta (hover + fin pekare) behåller den mjuka scrollen. */
  if (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

  // Lenis-rekommenderad bas-CSS (injiceras bara när Lenis faktiskt körs)
  var css =
    'html.lenis,html.lenis body{height:auto}' +
    '.lenis.lenis-smooth{scroll-behavior:auto !important}' +
    '.lenis.lenis-smooth [data-lenis-prevent]{overscroll-behavior:contain}' +
    '.lenis.lenis-stopped{overflow:hidden}' +
    '.lenis.lenis-smooth iframe{pointer-events:none}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var lenis = new Lenis({
    lerp: 0.14,          // högre = snärtigare/snabbare efterglid (var 0.09)
    smoothWheel: true,
    wheelMultiplier: 1.05,
    syncTouch: false     // touch = native momentum (smooth touch känns laggigt)
  });
  window.wubsLenis = lenis;

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // Interna VERTIKALA scroll-ytor: wheel där ska scrolla ytan, inte sidan.
  // (Karusellerna är MEDVETET INTE med här – de scrollar bara i sidled; med data-lenis-prevent
  //  sväljer den native overflow-x-behållaren vertikala hjul-events → sidan "fastnar" över dem.)
  // ⚠️ '.wubs-header__drawer' stod här – mobilmenyn heter .wubs-drawer, så den var ALDRIG undantagen och
  //    gick inte att scrolla när den blev högre än skärmen (2026-09-19). Snabbköpslådan saknades helt.
  //    Båda lådorna bär nu attributet i sin markup också; listan är reserven.
  var PREVENT = [
    'wubs-cart-drawer',
    'wubs-wishlist-drawer',
    'wubs-quick-add-drawer',
    '.wubs-header__searchbar',
    '.wubs-drawer',
    '.wubs-header__mega'
  ].join(',');
  function markPrevent(root) {
    (root || document).querySelectorAll(PREVENT).forEach(function (el) {
      el.setAttribute('data-lenis-prevent', '');
    });
  }
  markPrevent();

  // Horisontella karuseller: låt Lenis sköta VERTIKAL scroll (annars fastnar sidan över dem),
  // men stoppa horisontella gester från att nå Lenis så de scrollar karusellen i sidled nativt.
  var CAROUSEL = '.wubs-pcar__track, .wth-review-track, [data-wth-carousel-track]';
  document.querySelectorAll(CAROUSEL).forEach(function (track) {
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.stopPropagation(); // Lenis ser den ej → native scrollar karusellen i sidled
      }
      // vertikal gest: gör inget → bubblar till Lenis (mjuk sid-scroll, ingen "fastnar")
    }, { passive: true });
  });

  // Overlays låser sidan → stoppa Lenis så länge.
  // ⚠️ Våra egna lås sitter på <html> sedan 2026-09-12 (WubsScroll – body.overflow gjorde
  //    body till scroll-container och slog ut sticky). <body> observeras ändå: Dawns egna
  //    komponenter rör fortfarande den, och en observer som missar dem låter Lenis
  //    fortsätta scrolla sidan bakom en öppen overlay.
  var mo = new MutationObserver(function () {
    var last = document.documentElement.style.overflow === 'hidden' ||
               document.body.style.overflow === 'hidden';
    if (last) {
      lenis.stop();
    } else {
      lenis.start();
    }
  });
  mo.observe(document.body, { attributes: true, attributeFilter: ['style'] });
  mo.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });

  // Ankarlänkar (#id) → mjuk scroll i stället för hopp.
  // ⚠️ Offseten MÅSTE räkna med den klistrade headern. Lenis gör preventDefault(), så
  // CSS:ens `scroll-margin-top` (som bara gäller webbläsarens egen scroll) hoppas över –
  // med en fast liten offset landade målrubriken under headern och såg ut att missa.
  function ankarOffset() {
    var h = document.querySelector('wubs-header') || document.querySelector('.wubs-header');
    var hh = h ? Math.round(h.getBoundingClientRect().height) : 0;
    return hh + 20;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var hash = a.getAttribute('href');
    if (!hash || hash.length < 2) return; // "#" utan mål
    var target = document.getElementById(hash.slice(1));
    if (!target) return;
    e.preventDefault();
    lenis.scrollTo(target, { offset: -ankarOffset() });
  });
})();
